export default class FinancingSettingsDTO {
  annualFinancingRate: number;
  maxFinancingPercentage: number;
  incomeCommitmentPercentage: number;
  maxFinancingTermMonths: number;
  maxFinancingAgeMonths: number;

  constructor(
    annualFinancingRate: number,
    maxFinancingPercentage: number,
    incomeCommitmentPercentage: number,
    maxFinancingTermMonths: number,
    maxFinancingAgeMonths: number
  ) {
    this.annualFinancingRate = annualFinancingRate;
    this.maxFinancingPercentage = maxFinancingPercentage;
    this.incomeCommitmentPercentage = incomeCommitmentPercentage;
    this.maxFinancingTermMonths = maxFinancingTermMonths;
    this.maxFinancingAgeMonths = maxFinancingAgeMonths;
  }

  static fromJson(json: any): FinancingSettingsDTO {
    return new FinancingSettingsDTO(
      json.annualFinancingRate,
      json.maxFinancingPercentage,
      json.incomeCommitmentPercentage,
      json.maxFinancingTermMonths,
      json.maxFinancingAgeMonths
    );
  }

  toJson(): any {
    return {
      annualFinancingRate: this.annualFinancingRate,
      maxFinancingPercentage: this.maxFinancingPercentage,
      incomeCommitmentPercentage: this.incomeCommitmentPercentage,
      maxFinancingTermMonths: this.maxFinancingTermMonths,
      maxFinancingAgeMonths: this.maxFinancingAgeMonths,
    };
  }
}
